export const getColor = (color, theme) => {
  switch (color) {
    case 'course':
      return theme['color.purpleLight'];
    case 'lesson':
      return theme['color.blueLight'];
    default:
      return 'rgba(0,0,0,0.4)';
  }
};

export const getIcon = (icon) => {
  switch (icon) {
    case 'course':
      return 'duotoneCourse';
    case 'lesson':
      return 'duotoneLesson';
    default:
      return 'duotoneFile';
  }
};

export const getCourseWareNameFromPlugin = (plugin) => {
  const pluginList = {
    "Bronte Viewer eText Plugin": "Bronte Viewer",
    "Pearson eText course plugin": "ePub",
  };
  return plugin.type === "course" && pluginList[plugin.name] && (pluginList[plugin.name]);
}; 
